/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS18 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_17;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_18;
    },
    getDownloadName() {
      return ns.IOS18.nice_name;
    },
  });

  Object.assign(IOS18, {
    slug: `ios_18`,
    nice_name: `iOS 18 adoption`,
    description: `How quickly are consumers upgrading to iOS 18?`,
  });
  ns.IOS18 = IOS18;
});

}.call(window));